import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Couple icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Couple } from '@sravni/design-system-icons'
 *
 * <Couple />
 * ```
 */
var Couple = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Couple", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.165 6.322a1.667 1.667 0 1 1-2.358 2.357 1.667 1.667 0 0 1 2.358-2.357M15.543 5.61a2.083 2.083 0 1 1-2.946 2.946 2.083 2.083 0 0 1 2.946-2.946M17.82 15v-.834a2.5 2.5 0 0 0-2.5-2.5h-2.5a2.5 2.5 0 0 0-2.5 2.5V15M7.82 11.666H6.153a2.5 2.5 0 0 0-2.5 2.5V15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Couple };
//# sourceMappingURL=Couple.js.map
